import { Exclude, Expose } from 'class-transformer';
import { IsUUID } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { PhotoDto } from '../../photo/dto/photo.dto';
import { JobRepairPhotoInterface } from '../interfaces/job-repair-photo.interface';
import { JobRepairInterface } from '../../job-repair/interfaces/job-repair.interface';
import { JobRepairPhotoTypeEnum } from '../enums/job-repair-photo-type.enum';

@Exclude()
export class JobRepairPhotoDto
  extends PhotoDto
  implements JobRepairPhotoInterface
{
  @Expose()
  jobRepair?: JobRepairInterface | undefined;
  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Associated Job ID',
  })
  @IsUUID()
  @Expose()
  jobRepairId!: string;

  @ApiProperty({
    title: 'Job Repair Type Enum',
  })
  @Expose()
  repairPhotoType!: JobRepairPhotoTypeEnum;

  @ApiProperty({
    title: 'Deleted At',
  })
  @Expose()
  deletedAt?: Date;
}
